function isImageFile(file: File | null): file is File {
  return !!file && file.type.startsWith('image/');
}

function isVideoFile(file: File | null): file is File {
  return !!file && file.type.startsWith('video/');
}

/** Collect matching files from clipboard `.files` and `.items` (RME-style). */
export function getClipboardFiles(clipboardData: DataTransfer, accept: (file: File) => boolean): File[] {
  const seen = new Set<File>();
  const files: File[] = [];

  const add = (file: File | null) => {
    if (!file || seen.has(file) || !accept(file)) return;
    seen.add(file);
    files.push(file);
  };

  if (clipboardData.files?.length) {
    for (const file of Array.from(clipboardData.files)) {
      add(file);
    }
  }

  if (clipboardData.items?.length) {
    for (const item of Array.from(clipboardData.items)) {
      if (item.kind === 'file') {
        add(item.getAsFile());
      }
    }
  }

  return files;
}

/** Collect image files from clipboard `.files` and `.items` (RME-style). */
export function getClipboardImageFiles(clipboardData: DataTransfer): File[] {
  return getClipboardFiles(clipboardData, isImageFile);
}

/** Collect video files from clipboard `.files` and `.items`. */
export function getClipboardVideoFiles(clipboardData: DataTransfer): File[] {
  return getClipboardFiles(clipboardData, isVideoFile);
}
